import { render } from "./StylesReset.vue?vue&type=template&id=56ef9e63"
const script = {}

import "./StylesReset.vue?vue&type=style&index=0&id=56ef9e63&lang=css"
script.render = render

export default script